import {
  faCalendar,
  faHome,
  faUsers,
  faSchool,
} from '@fortawesome/free-solid-svg-icons'
import {
  faChartPie,
  faFile,
  faUnlock,
  faFileUpload,
  faCalendarCheck,
} from '@fortawesome/free-solid-svg-icons'
import { useDrawer } from '../../hooks/useDrawer'
import React, { useState } from 'react'
import { useLocation } from 'react-router'
import { Outlet } from 'react-router-dom'
// import LogRocket from 'logrocket'
import { Brand } from 'ui'
import { Layouts, Navigator } from 'ui/Templates'
import { useDebounce } from 'utils'
import { atPath } from './helpers'
import { SearchModalResults } from '../AppNavigator/SearchModal'
import { AdminProfileNav } from './AdminProfileNav'
import { useCurrentUser } from '../../queries'

export const AdminView: React.FC = () => {
  try {
    // Get drawer state and toggle from Redux hook
    const { drawerActive, drawerCompact, toggleDrawer } = useDrawer()
    console.log('AppNavigator: Drawer state from Redux', {
      drawerActive,
      drawerCompact,
    })
    const { pathname } = useLocation()
    const menuEnabled = pathname.indexOf('/admin/dashboard') !== 0
    const { data: profile } = useCurrentUser()

    const profileName = profile
      ? `${profile.firstName} ${profile.lastName}`
      : null
    const profileImage = profile?.avatarUrl
    const profileColor = profile?.color

    console.log('AdminView: Profile details:', {
      name: profileName || 'not set',
      hasImage: !!profileImage,
      hasColor: !!profileColor,
    })

    const [queryString, setQueryString] = useState('')
    const searchQuery = useDebounce(queryString, 450)

    // if (profile) {
    //   console.log('AdminView: Identifying user in LogRocket')
    //   try {
    //     LogRocket.identify(profile?.userId, {
    //       name: profileName ?? 'n/a',
    //     })
    //   } catch (logError) {
    //     console.error('AdminView: LogRocket identification error:', logError)
    //   }
    // }

    const handleSearchUpdate = (query: string) => {
      console.log('AdminView: Search query updated')
      setQueryString(query)
    }

    const renderSearchResults = () => {
      console.log('AdminView: Rendering search results')
      try {
        return (
          <SearchModalResults queryString={searchQuery} isAdminContext={true} />
        )
      } catch (error) {
        console.error('AdminView: Error rendering search results:', error)
        return <div>Error loading search results</div>
      }
    }

    const renderDrawerItems = () => {
      console.log('AdminView: Rendering drawer items')
      try {
        return (
          <>
            <Navigator.Item
              to="/admin/dashboard"
              active={atPath('/admin/dashboard')}
              label="Dashboard"
              icon={faHome}
            />
            <Navigator.Item
              to="/admin/profiles"
              active={atPath('/admin/profiles')}
              label="User Profiles"
              icon={faUsers}
            />
            <Navigator.Item
              to="/admin/events"
              active={atPath('/admin/events')}
              label="Events"
              icon={faCalendar}
            />
            {/* <Navigator.Item
            to="/admin/invitations"
            active={atPath('/admin/invitations')}
            label="Invitations"
            icon={faCalendarCheck}
          /> */}
            <Navigator.Item
              to="/admin/resources"
              active={atPath('/admin/resources')}
              label="Resources"
              icon={faFile}
            />
            <Navigator.Item
              to="/admin/reports"
              active={atPath('/admin/reports')}
              label="Reports"
              icon={faChartPie}
            />
            <Navigator.Item
              to="/admin/roles"
              active={atPath('/admin/roles')}
              label="Admin Roles"
              icon={faUnlock}
            />
            <Navigator.Item
              to="/admin/schools"
              active={atPath('/admin/schools')}
              label="Schools"
              icon={faSchool}
            />
          </>
        )
      } catch (error) {
        console.error('AdminView: Error rendering drawer items:', error)
        return <></>
      }
    }

    return (
      <Layouts.AppNavigator
        // Pass drawer state and toggle function as props
        drawerActive={drawerActive}
        drawerCompact={drawerCompact}
        toggleDrawer={toggleDrawer}
        renderDrawerItems={renderDrawerItems}
        profileNavigation={AdminProfileNav}
        profileName={(profileName as string) || 'User'}
        profileColor={(profileColor as string) || '#333333'}
        profileImage={(profileImage as string) || ''}
        onSearchUpdate={handleSearchUpdate}
        renderSearchResults={renderSearchResults}
        logo={Brand.EpcAdminLogo}
        searchEnabled
        menuEnabled={menuEnabled}
        profileNavEnabled
        showFooter={false}
        appearance="secondary"
        hasDrawer
      >
        <Outlet />
      </Layouts.AppNavigator>
    )
  } catch (error) {
    console.error('AdminView: Unexpected error:', error)
    return (
      <div style={{ padding: 20 }}>
        <h2>Error loading Admin View</h2>
        <p>There was an error loading the admin interface.</p>
        <details>
          <summary>Error details</summary>
          <pre>{String(error)}</pre>
        </details>
      </div>
    )
  }
}
